var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entry)?_c('div',[(_vm.isSite)?_c('NavbarSite',{key:_vm.$vnode.key}):_vm._e(),(_vm.isDropdown)?_c('NavbarDropdown',{key:_vm.$vnode.key}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }